// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__8ZV3N","FooterLink":"Footer_FooterLink__3ha83","FooterInnerDiv":"Footer_FooterInnerDiv__2KG_j"};